import { WebPlugin } from '@capacitor/core';
export class VideoDataBridgeWeb extends WebPlugin {
    async openVideo(videoData) {
        console.log(videoData);
        return { success: true };
    }
    async openDownloadsPage() {
        console.log('navigating to downloads page');
        return { success: true };
    }
}
//# sourceMappingURL=web.js.map